export default "__VITE_ASSET__7a8de980__"